const exchangeAutoComplete = () =>
  import("@/components/ExchangeAutoComplete/index");
const TagCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/TagCard/index");
const addAddressCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/AddAddressCard/index");
const deleteAddressCard = () =>
  import(
    "@/components/OperationsPage/Withdrawal/Crypto/DeleteAddressCard/index"
  );
const sendMobileCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/SendMobileCard/index");
const otpCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/OtpCard/index");
// const extraFeeCard = () =>
//   import("@/components/OperationsPage/Withdrawal/Crypto/ExtraFeeCard/index");
const CanceledOrderCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/CanceledOrderCard");
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import Stepper from "@/components/Shared/Stepper/index.vue"
// import Num2persian from "num2persian";
const NumberInput = () => import("@/components/NumberInput/index");
const OtpVerify = () => import("@/components/Shared/OtpVerify/index");

import $thousandMask from "@/mixins/thousandMask";
import $carrySignFixed from "@/mixins/carrySignFixed";
import $exponent from "@/mixins/exponent";

import {
  OperationService,
  UserService,
  WalletService,
  CurrenciesService
} from "@/services";
export default {
  name: "crypto",
  components: {
    exchangeAutoComplete,
    TagCard,
    addAddressCard,
    deleteAddressCard,
    sendMobileCard,
    otpCard,
    // extraFeeCard,
    NumberInput,
    CanceledOrderCard,
    OtpVerify,
    Stepper
  },
  props: [],
  mixins: [$thousandMask, $carrySignFixed, $exponent],
  data() {
    return {
      selectedAddress: "",
      selectedNetworkAddr: "",
      showTagInput: false,
      networkExtra: "",
      modalStatus: "",
      dialog: false,
      removedAddress: {},
      phoneNumber: "",
      isNetworkSelected: false,
      selectedNetwork: "",
      orderAmount: "",
      orderId: "",
      walletAddressesList: [],
      isExtraOptional: false,
      loading: false,
      walletAddressData: {},
      max: true,
      addressValidation: "",
      addAddressId: "",
      countdownTimer: "",
      isCounterExpired: "",
      clockInterval: "",
      addAddressLoading: false,
      otpLoading: false,
      deleteAddressLoading: false,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      amount: null,
      showValidation: true,
      isMobileVerified: true,
      userVerification: {},
      channelLabel: [],

      /////////////////
      getCurrencies: [],
      getWallets: {},
      getExchanges: {},
      isCurrencyLoaded: false,
      isWalletLoaded: false,
      isExchangeLoaded: false,
      selectedCurrency: "",
      availableAmount: "0",
      exponent: 0,
      currencies: [],
      networks: [],
      minWithdraw: null,
      maxWithdraw: null,
      step:1
    };
  },
  computed: {
    ...mapGetters({
      // getCurrencies: types.currencies.getters.GET_CURRENCIES,
      // getExchanges: types.wallets.getters.GET_EXCHANGE_WALLETS,
      // getWallets: types.operations.getters.GET_WALLET,
      getWithdrawCurrencies: types.operations.getters.GET_WITHDRAW_CURRENCIES,
      getUserInfo: types.userInfo.getters.GET_USER_INFO
    }),
    setMobileNumber() {
      if (Object.entries(this.getUserInfo).length !== 0) {
        return this.getUserInfo.mobile;
      }
    },
    isVerify() {
      return !!this.getUserInfo.actions?.withdraw_crypto?.is_active;
    },
    trimmedOrderAmount() {
      return parseFloat(String(this.orderAmount).trim());
    },
    netAmountReceived() {
      return this.networkTransferFee && this.trimmedOrderAmount
        ? this.$thousandMask(
            this.$exponent(
              this.$carrySignFixed(
                this.trimmedOrderAmount,
                this.networkTransferFee,
                "-"
              )
            )
          )
        : 0;
    },
    currencyIsoQuery() {
      return this.$route.query.from;
    },
    setCurrencies() {
      let data = [];
      if (Object.entries(this.getWallets).length > 0) {
        this.getWallets.wallets.forEach(elem => {
          if (elem.is_withdraw_active && elem.currency.iso !== "IRR") {
            data.push(elem);
          }
        });
        return data;
      }
    },
    setFromCurrency() {
      let data = {};
      // if (
      //   Object.entries(this.getWallets).length > 0 &&
      //   Object.entries(this.getWithdrawCurrencies).length > 0
      // ) {
      if (Object.entries(this.getWallets).length > 0) {
        data = this.setCurrencies.find(elem => {
          if (elem.currency.iso === this.$route.query.from) {
            return elem;
          }
        });
        if (!data) {
          this.$router.push({
            query: { from: this.getWithdrawCurrencies[0].currency.iso }
          });
          data = this.getWithdrawCurrencies[0];
        }
        return data;
      }
    },
    currencyNetworks() {
      if (this.setFromCurrency) {
        return this.setFromCurrency.networks;
      }
    },
    fromCurrencyData() {
      // if (Object.entries(this.getCurrencies).length > 0) {
      //   return this.getCurrencies.find((elem) => {
      //     if (elem.iso === this.$route.query.from) {
      //       return elem;
      //     }
      //   });
      // }

      //after refactor
      let selectedCurrency = this.currencies.find(
        item => item.iso == this.selectedCurrency
      );
      return selectedCurrency ? selectedCurrency : {};
    },
    currencyNetworkData() {
      // if (this.fromCurrencyData && this.selectedNetwork) {
      //   console.log(JSON.parse(JSON.stringify(this.fromCurrencyData)));
      //   return this.fromCurrencyData.networks.find((elem) => {
      //     if (elem.name === this.selectedNetwork.title) {
      //       return elem;
      //     }
      //   });
      // }

      //after refactor
      return this.selectedNetwork;
    },
    walletAddressRegex() {
      // return this.currencyNetworkData.regex;

      //after refactor
      return this.selectedNetwork.regex;
    },
    networkTransferFee() {
      // if (this.currencyNetworkData) {
      //   return this.$exponent(
      //     parseFloat(this.currencyNetworkData.transfer_fee)
      //   );
      // }

      //after refactor
      if (this.selectedNetwork) {
        return this.$exponent(
          parseFloat(this.selectedNetwork.transfer_fee.amount)
        );
      }
    },
    networkTransferFeeBecq() {
      if (this.selectedNetwork) {
        return this.$exponent(
          parseFloat(this.selectedNetwork.transfer_fee.bceq)
        );
      }
    },
    currencyNetworkAdrr() {
      if (this.setFromCurrency) {
        return this.setFromCurrency.addresses;
      }
    },
    hasExtra() {
      if (this.setFromCurrency) {
        return !!this.setFromCurrency.currency.extra_name;
      }
    },
    cryptoExchange() {
      this.showValidation = true;
      // let min,
      //   max,
      //   balance,
      //   iso = "";
      // if (
      //   Object.entries(this.getExchanges).length > 0 &&
      //   Object.entries(this.getWallets).length > 0
      // ) {
      //   this.getWallets.wallets.find((item) => {
      //     if (item.currency.iso === this.$route.query.from) {
      //       balance = parseFloat(item.balance_string_format);
      //     }
      //   });
      //   this.getExchanges[this.$route.query.from].find((elem) => {
      //     if (elem.to === this.$route.query.from) {
      //       min = parseFloat(elem.minimum_amount_to);
      //       max = parseFloat(elem.maximum_amount_to);
      //       iso = elem.to;
      //     }
      //   });
      //   if (this.orderAmount === 0 || this.orderAmount === "") {
      //     return "";
      //   } else if (this.orderAmount > balance) {
      //     return "موجودی کیف پول شما کافی نیست.";
      //   } else if (this.orderAmount > max) {
      //     return `حداکثر مقدار قابل برداشت ${this.$thousandMask(
      //       max
      //     )} ${iso} است.`;
      //   } else if (this.orderAmount < min) {
      //     return `حداقل مقدار قابل برداشت ${this.$thousandMask(
      //       min
      //     )} ${iso} است.`;
      //   } else {
      //     return "";
      //   }
      // }

      //after refactor
      if (this.orderAmount === 0 || this.orderAmount === "") {
        return "";
      } else if (
        parseFloat(this.orderAmount) > parseFloat(this.availableAmount)
      ) {
        return this.$t("operationsPage.transfer.balanceNotEnought");
      } else if (parseFloat(this.orderAmount) > parseFloat(this.maxWithdraw)) {
        return this.$t("operationsPage.transfer.maxTransfer", {
          amount: `${this.$thousandMask(this.maxWithdraw)} ${
            this.selectedCurrency
          }`
        });
      } else if (parseFloat(this.orderAmount) < parseFloat(this.minWithdraw)) {
        return this.$t("operationsPage.transfer.minTransfer", {
          amount: `${this.$thousandMask(this.minWithdraw)} ${
            this.selectedCurrency
          }`
        });
      } else {
        return "";
      }
    },
    filteredWalletAddresses() {
      if (this.walletAddressesList.length > 0) {
        return this.walletAddressesList.filter(elem => {
          if (elem.currency === this.selectedCurrencyObject.iso) {
            return elem;
          }
        });
      } else {
        return [];
      }
    },
    checkForm() {
      if (
        this.orderAmount.length &&
        this.orderAmount > 0 &&
        this.selectedAddress.length &&
        !this.addressValidation
      )
        return false;
      else return true;
    },

    selectedCurrencyObject() {
      let selectedCurrency = this.currencies.find(
        item => item.iso == this.selectedCurrency
      );
      return selectedCurrency ? selectedCurrency : null;
    }
  },
  watch: {
    selectedNetwork: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue.has_extra) {
          this.showTagInput = true;
        }
      }
    }
  },
  mounted() {
    this.getAddressesList();
    // this.getUserData();
    this.getUserInformation();
    // this.getCurrenciesService();
    // this.getWalletService();
    // this.getExchangeService();
    this.getWithdrawalCurrencies();
  },
  methods: {
    channelLabelFunc(data) {
      this.channelLabel = data;
    },
    getUserInformation() {
      UserService.getVerifyInfo().then(response => {
        this.userVerification = response.data.data;
        this.isMobileVerified = response.data.data.is_mobile_verified;
      });
    },
    // getUserData() {
    //   AuthService.userInfo().then(response => {
    //     this.phoneNumber = response.data.data.mobile;
    //   });
    // },
    async updateFromCurrency(data) {
      if(!data){
        return
      }
      if (data != this.$route.query.from) {
        this.$router.push({ query: { from: data } });
      }
      await WalletService.getWalletDetailsV2(data).then(res => {
        this.availableAmount = res.data.data.balance.available;
        this.selectedCurrency = data;
        this.exponent = res.data.data.exponent;
      });
      //check networks
      await OperationService.getNetworkV2(this.selectedCurrency).then(
        response => {
          this.networks = response.data.data.networks;
          this.minWithdraw =
            response.data.data.limitation_amount?.withdraw?.min;
          this.maxWithdraw =
            response.data.data.limitation_amount?.withdraw?.max;
        }
      );
      this.selectedNetwork = "";
      this.showTagInput = false;
      this.selectedAddress = "";
      this.networkExtra = "";
      this.amount = "";
      this.orderAmount = "";
    },
    onAddAddress() {
      this.modalStatus = "addAddress";
      this.dialog = !this.dialog;
    },
    onConfirmAddAddr(walletData, loading) {
      this.addAddressLoading = loading;
      this.walletAddressData = walletData;
      this.addAddressWallet();
    },
    sendVerificationSms(id) {
      let data = {
        mobile: this.setMobileNumber,
        address_id: id
      };
      OperationService.sendAddressOtpCode(data).then(response => {
        this.countdown(response.data.data.ttl / 1000);
      });
    },
    addAddressWallet() {
      let data = {
        currency_id: this.selectedCurrencyObject.id,
        network_id: this.selectedNetwork.id,
        name: this.walletAddressData.title,
        address: this.walletAddressData.address,
        address_extra: this.walletAddressData.networkTag
      };
      OperationService.addWalletAddress(data)
        .then(response => {
          this.$toast.success(response.data.message);
          this.modalStatus = "confirmOtp";
          this.addAddressId = response.data.data.id;
          this.sendVerificationSms(response.data.data.id);
        })
        .finally(() => {
          this.addAddressLoading = false;
        });
    },
    onRemoveAddress(item) {
      this.modalStatus = "deleteAddress";
      this.removedAddress = item;
      this.dialog = !this.dialog;
    },
    onSelectNetwork() {
      // if (this.showTagInput) {
      //   this.showTagInput = false;
      // } else
      if (this.hasExtra) {
        this.modalStatus = "addTag";
        this.dialog = !this.dialog;
      }
      this.validationInAddress(this.selectedAddress);
    },
    onSelectAddress(walletAddress) {
      if (typeof walletAddress === "object") {
        this.selectedAddress = walletAddress.address;
        if (walletAddress.address_extra) {
          this.networkExtra = walletAddress.address_extra;
          this.showTagInput = true;
        }
      } else {
        this.selectedAddress = walletAddress;
        this.networkExtra = "";
      }
      this.validationInAddress(this.selectedAddress);
    },
    validationInAddress(address) {
      if (!address.match(this.walletAddressRegex)) {
        this.addressValidation = this.$t(
          "operationsPage.withdraw.category.crypto.addressNotCorrect"
        );
      } else {
        this.addressValidation = "";
      }
      if (!address) {
        this.addressValidation = "";
      }
    },
    confirmTagWarning(event) {
      this.showTagInput = true;
      this.dialog = event;
    },
    onConfirmDeleteAddr(event, loading) {
      this.deleteAddressLoading = loading;
      let data = {
        address_id: this.removedAddress.id
      };
      OperationService.deleteWalletAddress(data)
        .then(response => {
          this.selectedAddress = "";
          this.$toast.success(response.data.message);
          this.dialog = event;
          this.getAddressesList();
        })
        .finally(() => {
          this.deleteAddressLoading = false;
        });
    },
    onConfirmOtp(code, loading) {
      this.otpLoading = loading;
      let data = {
        mobileCode: code,
        address_id: String(this.addAddressId)
      };
      OperationService.verifyAddressOtp(data)
        .then(() => {
          this.dialog = false;
          this.isCounterExpired = false;
          this.getAddressesList();
        })
        .finally(() => {
          this.otpLoading = false;
        });
    },
    onConfirmFee(event) {
      this.$router.push(
        `/submit-order/${this.orderId}/withdrawal/crypto`,
        () => {}
      );
      this.dialog = event;
    },
    orderCryptoWithdraw() {
      this.loading = true;

      let data = {
        amount: this.orderAmount,
        network_id: this.selectedNetwork.id,
        currency_id: this.selectedCurrencyObject.id,
        to_address: this.selectedAddress.address
          ? this.selectedAddress.address
          : this.selectedAddress,
        to_address_extra: this.networkExtra,
        transfer_fee: this.networkTransferFee,
        to_address_extra_required: !this.isExtraOptional
      };

      OperationService.withdrawCrypto(data)
        .then(response => {
          this.orderId = response.data.data.ref_no;
          let changeFee = parseFloat(response.data.data.change_fee);
          if (changeFee) {
            this.modalStatus = "confirmExtraFee";
            this.dialog = true;
          } else {
            this.$router.push(
              `/submit-order/${this.orderId}/withdrawal/crypto`,
              () => {}
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAddressesList() {
      OperationService.getWalletAddresses().then(response => {
        this.walletAddressesList = response.data.data;
      });
    },
    countdown(distance) {
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    onConfirmResendOtp(ttl) {
      this.countdown(ttl);
      this.isCounterExpired = false;
    },
    onCancelOrderCard(event) {
      if (event) {
        this.modalStatus = "confirmOtp";
      }
    },
    openCancelOrder(event) {
      if (event) {
        this.modalStatus = "canceledOrderCard";
      }
    },

    getCurrenciesService() {
      CurrenciesService.getCurrencies().then(async response => {
        this.getCurrencies = response.data.data;
        this.isCurrencyLoaded = true;
      });
    },
    getWalletService() {
      WalletService.getWalletV4().then(response => {
        this.getWallets = response.data.data;
        this.isWalletLoaded = true;
      });
    },
    getExchangeService() {
      WalletService.getExchanges().then(response => {
        this.getExchanges = response.data.data;
        this.isExchangeLoaded = true;
      });
    },

    getWithdrawalCurrencies() {
      OperationService.getWithdrawalCurrenciesV2().then(async response => {
        this.currencies = response.data.data;
        this.isCurrencyLoaded = true;
        // if (!this.$route.query.from) {
        //   this.selectedCurrency = this.currencies[0].iso;
        //   this.$router.push({
        //     query: {
        //       from: this.currencies[0].iso
        //     }
        //   });
        // } else {
          this.selectedCurrency = this.$route.query.from;
        // }
        await this.updateFromCurrency(this.selectedCurrency);
      });
    }
  }
};
